import { render } from "./MetaTitleSection.vue?vue&type=template&id=54a21061&scoped=true"
import script from "./MetaTitleSection.vue?vue&type=script&lang=js"
export * from "./MetaTitleSection.vue?vue&type=script&lang=js"

import "./MetaTitleSection.vue?vue&type=style&index=0&id=54a21061&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a21061"]])

export default __exports__